import AppThemeIcon from "@core-components/icon/AppThemeIcon";
import Icon from "@core-components/icon/Icon";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Button, Checkbox, Indicator, Menu } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";

interface IPriceSelectProps {
  values: string[];
  onChange: (value: string[]) => void;
}

interface IOption {
  label: string;
  value: string;
}

const options: IOption[] = [
  {
    label: "0€ - 15€",
    value: "0-15",
  },
  {
    label: "15€ - 30€",
    value: "15-30",
  },
  {
    label: "30€ - 50€",
    value: "30-50",
  },
  {
    label: "50€ - 100€",
    value: "50-100",
  },
  {
    label: "100€+",
    value: "100-10000",
  },
];

const PriceSelect: React.FC<IPriceSelectProps> = ({ values, onChange }) => {
  const { t } = useAppTranslation("components.rankedFilters");
  return (
    <Menu>
      <Menu.Target>
        <Indicator
          processing
          classNames={{
            indicator: "before:bg-secret-blue-light bg-secret-blue-light z-10",
          }}
          disabled={values.length === 0}
        >
          <Button
            classNames={{
              root: "default-icon border-primary-lighter",
              section: "contents",
            }}
            leftSection={
              <AppThemeIcon className="size-7">
                <Icon.Euro className="pr-2" />
              </AppThemeIcon>
            }
            radius={8}
            rightSection={<IconChevronDown />}
          >
            {t("price.label")}
          </Button>
        </Indicator>
      </Menu.Target>

      <Menu.Dropdown
        classNames={{
          dropdown: "bg-primary-default border-secret-blue-light p-3",
        }}
      >
        <Checkbox.Group value={values} onChange={onChange}>
          {options.map((option) => {
            return (
              <Checkbox
                key={option.value}
                labelPosition="left"
                classNames={{
                  root: "cursor-pointer hover:bg-primary-background p-1 rounded-md",
                  label: "cursor-pointer p-1",
                  labelWrapper: "w-full",
                  body: "py-1 text-white",
                  input: "!bg-transparent border-none",
                  inner: "my-auto",
                }}
                iconColor="white"
                label={option.label}
                value={option.value}
              />
            );
          })}
        </Checkbox.Group>
      </Menu.Dropdown>
    </Menu>
  );
};

export default PriceSelect;
